export const clientUrls = {
    baseUrl: () => "/",

    users: {
        baseUrl: () => "/users",
        create: () => `${clientUrls.users.baseUrl()}/create`,
        edit: () => `${clientUrls.users.baseUrl()}/edit`
    },

    customers: {
        baseUrl: () => "/customers",
        create: () => `${clientUrls.customers.baseUrl()}/create`,
        edit: () => `${clientUrls.customers.baseUrl()}/edit`
    },

    roles: {
        baseUrl: () => "/roles",
        create: () => `${clientUrls.roles.baseUrl()}/create`,
        edit: () => `${clientUrls.roles.baseUrl()}/edit`
    },

    permissions: {
        baseUrl: () => "/permissions",
        create: () => `${clientUrls.permissions.baseUrl()}/create`,
        edit: () => `${clientUrls.permissions.baseUrl()}/edit`
    },

    authentication: {
        baseUrl: () => "/authentication",
        login: () => `${clientUrls.authentication.baseUrl()}/login`,
        activate: token => `${clientUrls.authentication.baseUrl()}/activate/${token}`
    },

    header: { logout: () => "/", settings: () => "/settings" },

    legal: {
        cookies: () => "/cookies",
        imprint: () => "/imprint",
        privacyPolicy: () => "/privacy_policy"
    }
};
